import { WWW_ORIGIN } from './resolve-href.js';

// Build the footer's JSON-LD (schema.org ItemList of SiteNavigationElement) from
// the SAME semantic data the footer renders, so structured data and the visible
// footer never drift. JSON-LD URLs are ALWAYS absolute, so internal links are
// emitted against WWW_ORIGIN regardless of the consuming host.

function absoluteUrl(link) {
  if (!link) return undefined;
  if (link.type === 'external') return link.url;
  return `${WWW_ORIGIN}${link.path}`;
}

export function buildFooterJsonLd(columns) {
  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Postman Footer Navigation',
    description:
      'Main site navigation for Postman, the API platform for building, testing, and collaborating on APIs.',
    itemListElement: columns.map((col, i) => ({
      '@type': 'SiteNavigationElement',
      position: i + 1,
      name: col.title,
      // `jsonLdName` where the SEO name differs from the visible label ("App
      // Security APIs" vs "App Security") — see the note in footer-data.js.
      // Falling back to `title` keeps items that use one string for both.
      hasPart: col.items.map((item) => ({
        '@type': 'SiteNavigationElement',
        name: item.jsonLdName ?? item.title,
        url: absoluteUrl(item.link),
      })),
    })),
  };
}
